export default __webpack_public_path__ + "static/media/552.801dcaf0.png";